import { render, staticRenderFns } from "./AssetableMedia.vue?vue&type=template&id=09ed8a7c"
import script from "./AssetableMedia.vue?vue&type=script&lang=js"
export * from "./AssetableMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports